const general = {
    placeholder: 'Platzhalter',
    submit: 'Senden',
    skip: 'Überspringen',
    next: 'Weiter',
    back: 'Zurück',
    retry: 'Erneut versuchen',
    done: 'Fertig',
    search: 'Suche',
    search_placeholder: 'Suchen',
    clear_result: 'Ergebnisse löschen',
    save: 'Speichern',
    save_changes: 'Änderungen speichern',
    saved: 'Gespeichert',
    discard: 'Verwerfen',
    loading: 'Lade...',
    redirecting: 'Weiterleiten...',
    add: 'Hinzufügen',
    added: 'Hinzugefügt',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    check_out: 'Ansehen',
    create: 'Erstellen',
    set_up: 'Einrichten',
    customize: 'Anpassen',
    enable: 'Aktivieren',
    reminder: 'Erinnerung',
    delete: 'Löschen',
    /** UNTRANSLATED */
    deleted: 'Deleted',
    more_options: 'MEHR OPTIONEN',
    close: 'Schließen',
    copy: 'Kopieren',
    copying: 'Kopiere',
    copied: 'Kopiert',
    required: 'Erforderlich',
    add_another: 'Weitere hinzufügen',
    create_another: 'Erstellen Sie ein anderes',
    deletion_confirmation: 'Willst du {{title}} wirklich löschen?',
    settings_nav: 'Einstellungen',
    unsaved_changes_warning: 'Du hast ungespeicherte Änderungen. Willst du diese Seite wirklich verlassen?',
    leave_page: 'Seite verlassen',
    stay_on_page: 'Auf Seite bleiben',
    type_to_search: 'Tippe um zu suchen',
    got_it: 'Alles klar',
    continue: 'Fortsetzen',
    page_info: '{{min, number}}-{{max, number}} von {{total, number}}',
    learn_more: 'Mehr erfahren',
    tab_errors: '{{count, number}} Fehler',
    skip_for_now: 'Jetzt überspringen',
    remove: 'Entfernen',
    visit: 'Besuchen',
    join: 'Beitreten',
    try_now: 'Jetzt ausprobieren',
    multiple_form_field: '(Mehrere)',
    demo: 'Demo',
    unnamed: 'Unbenannt',
    view: 'Anzeigen',
    /** UNTRANSLATED */
    open: 'Open',
    hide: 'Verbergen',
    unknown_error: 'Unbekannter Fehler, bitte versuchen Sie es später erneut.',
    select: 'Auswählen',
    contact_us_action: 'Kontaktiere uns',
    description: 'Beschreibung',
    name: 'Name',
    add_field: 'Füge {{field}} hinzu',
    create_field: 'Erstelle {{field}}',
    edit_field: 'Bearbeite {{field}}',
    delete_field: 'Lösche {{field}}',
    coming_soon: 'Demnächst verfügbar',
};
export default Object.freeze(general);
